import { QueryClient, QueryClientProvider } from 'react-query'
import { store } from 'store'
import { Provider as ReduxProvider } from 'react-redux'
import { AuthProvider } from 'components/Auth'
import { NotificationProvider } from 'components/Notification'
import { SettingsProvider } from 'components/Settings'

export default function Providers({ children }) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: false,
        staleTime: 1000 * 60 * 60 * 24,
      },
    },
  })
  return (
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <AuthProvider>
          <NotificationProvider>
            <SettingsProvider>{children}</SettingsProvider>
          </NotificationProvider>
        </AuthProvider>
      </ReduxProvider>
    </QueryClientProvider>
  )
}
